import { render, staticRenderFns } from "./view.vue?vue&type=template&id=6f49b420&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f49b420",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f49b420')) {
      api.createRecord('6f49b420', component.options)
    } else {
      api.reload('6f49b420', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=6f49b420&scoped=true&", function () {
      api.rerender('6f49b420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/constructionProjectMgr/projectMgr/view.vue"
export default component.exports